import React from 'react';

import Unauthorized from '../../components/login/Unauthorized';

const UnauthorizedPage = () => {
  return <Unauthorized />;
};

export default UnauthorizedPage;
